import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { CalculatedConsumablesDemandTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<CalculatedConsumablesDemandTheme>;
const css = baseCss as ThemedCssFunction<CalculatedConsumablesDemandTheme>;

export const CalculatedConsumablesDemand = styled.div`
  width: 100%;
  height: 100%;
`;
